export const version = "web/5.1.0";
